import React, { useEffect, useState } from 'react';
import { CarouselEvent, InputSearchGray, Layout } from '../../../components';
import DynamicFaIcon from '../../../components/atoms/DynamicFaIcon';
import { Link, useNavigate } from 'react-router-dom';
import { Tevent } from '../../../type/event';
import { getEventNextMonthActive } from '../../../service/eventService';
import { FiCalendar } from 'react-icons/fi';
import { MINIO } from '../../../data/data';
import { MonthAsByDate } from '../../../utls/date';

const Events = () => {
	const [keyword, setKeyword] = useState('');
	const [eventList, setEventList] = useState<Tevent[]>([]);

	const navigator = useNavigate();

	const getDataCarousel = async () => {
		const response = await getEventNextMonthActive();
		if (!response?.error) {
			setEventList(response?.data);
		}
	};

	useEffect(() => {
		getDataCarousel();
	}, []);

	return (
		<Layout
			showNavBar={false}
			showNavigation={true}
		>
			<div className="mb-[7rem] min-h-screen overflow-auto">
				<div className="my-5 flex gap-5 justify-between items-center ">
					<InputSearchGray
						value={keyword}
						onChange={(e) => {
							setKeyword(e.target.value);
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								navigator(`/admin/events/all?keyword=${encodeURI(keyword)}`);
							}
						}}
						icon={'FaSistrix'}
						placeholder="Cari Informasi Event"
					/>
					<button>
						<DynamicFaIcon name={'FaBell'} />
					</button>
				</div>
				<div className="flex justify-between">
					<h1 className="text-[12px]">Event Dalam Bulan Ini</h1>
					<Link
						className="text-[12px]"
						to={'/admin/events/all'}
					>
						Lihat Semua
					</Link>
				</div>
				<div className="mt-4">
					<CarouselEvent />
				</div>
				<h1 className="text-[12px]">Event Mendatang</h1>
				<div className="mt-4">
					{eventList.map((item: Tevent, index: number) => {
						const text = item.content_plain || '';
						const plain = text.substring(0, 100);
						const date = new Date(item.startDate);
						const day = date.getDate();
						return (
							<div
								key={index}
								className="flex mb-4"
							>
								<div className="relative bg-gray-50 text-center overflow-hidden max-w-[100px] max-h-[100px] rounded-sm">
									<Link to={`/admin/events/${item.slug}`}>
										<div className="bg-[#171766] absolute overflow-hidden px-2 py-1 bottom-0 right-0 text-white text-center rounded-sm">
											<span className="block p-0 m-0 text-[11px]">{day}</span>
											<span className="block p-0 m-0 text-[11px]">
												{MonthAsByDate(item.startDate)}
											</span>
										</div>
										<img
											src={`${MINIO}/${item.thumbnail}`}
											className=""
											alt={item.name}
										/>
									</Link>
								</div>
								<div className="ml-3">
									<Link to={`/admin/events/${item.slug}`}>
										<h2 className="text-[13px] font-medium block">
											{item.name}
										</h2>
									</Link>
									<span className="text-[10px] text-gray-400 m-0 p-0 flex items-center">
										<FiCalendar className="mr-2" />
										{new Date(item.createDate).toLocaleDateString()} -{' '}
										{new Date(item.createDate).toLocaleTimeString()}
									</span>
									<p className="text-[11px] text-justify">{plain}...</p>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</Layout>
	);
};

export default Events;
